import { useSelector } from 'react-redux';
import { get } from 'lodash';

const ReferenceRecord = ({ id, reference, children }) => {
  const record = useSelector(state => get(state.admin.resources, `${reference}.data.${id}`));
  return children(record || {});
};

export default ReferenceRecord;
